import React, { useMemo } from "react";
import { brandIdentityApi, useAppSelector } from "@litres-core/store";
import { useTranslation } from "@litres-libs/i18n";
import { isMobileOperatorDomain, isRostelecomDomain } from "@litres/utils";
import { MainLogo } from "../Logo/MainLogo";
import { useAvailableSubscriptions } from "../SubscriptionSwitcher/hooks";

import styles from "./MobileOperatorLogo.module.scss";

export const MobileOperatorLogo = () => {
  const { t, i18n } = useTranslation();
  const clientHost = useAppSelector(
    state => state.browser.headers["client-host"]
  );

  const { data: brandIdentity } = brandIdentityApi.useGetBrandIdentityQuery(
    undefined,
    {
      skip:
        clientHost === "www.litres.ru" ||
        !(isRostelecomDomain(clientHost) || isMobileOperatorDomain(clientHost)),
    }
  );

  const subscriptions = useAvailableSubscriptions();

  const brandIdentityForCurrentDomain = useMemo(() => {
    if (!subscriptions || subscriptions.length === 0) {
      return undefined;
    }
    const host = clientHost.replace("www.", "").replace("pda", "");
    if (host === "litres.ru") {
      return subscriptions[0];
    }
    return subscriptions.find(sub => sub.host === host);
  }, [clientHost, subscriptions]);

  if (
    !brandIdentityForCurrentDomain?.short_name &&
    !brandIdentity?.short_name
  ) {
    return <MainLogo />;
  }

  // brandIdentity - существует для рега и анрега. Некорректно отражает название подписки, если их несколько у оператора
  // brandIdentityForCurrentDomain - верно отражает название, но работает только для рега
  const color =
    brandIdentityForCurrentDomain?.primary_color ??
    brandIdentity?.primary_color ??
    undefined;

  const short_name =
    i18n.language === "ru-RU"
      ? (brandIdentityForCurrentDomain?.short_name_ru ??
        brandIdentity?.short_name_ru)
      : (brandIdentityForCurrentDomain?.short_name ??
        brandIdentity?.short_name);

  return (
    <div className={styles.logoWrapper}>
      <MainLogo />
      <div className={styles.operator}>
        {t("Подписка")}
        <span
          className={styles.operator__name}
          style={{
            color,
          }}
        >
          {short_name}
        </span>
      </div>
    </div>
  );
};
